import { useCallback, useState } from "react";

type Props = {
  isAddingOrDeleting: boolean;
  isUpdating: boolean;
  updatingRecord: any;
  applyForAll: boolean; // When a season/fixture task is not created yet, mark all records as busy
};

export const useRecordsState = ({ isAddingOrDeleting, isUpdating, updatingRecord, applyForAll }: Props) => {
  const [recordsBeingBusy, setRecordsBeingBusy] = useState<Array<any>>([]);

  const checkIfRecordBeingBusy = useCallback(
    (record: any) =>
      (isUpdating && (applyForAll || record === updatingRecord)) ||
      (isAddingOrDeleting && (applyForAll || recordsBeingBusy.find((x) => x === record))),
    [isAddingOrDeleting, isUpdating, updatingRecord, recordsBeingBusy, applyForAll]
  );

  const addBusyRecords = (records: Array<any>) => setRecordsBeingBusy((prev) => [...new Set([...prev, ...records])]);

  const deleteBusyRecords = (records: Array<any>) =>
    setRecordsBeingBusy((prev) => prev.filter((x) => !records?.find((y) => y === x)));

  const ensureRecordsBusy = async (records: Array<any>, funcAsync: () => Promise<void>) => {
    addBusyRecords(records);
    try {
      await funcAsync?.();
    } finally {
      deleteBusyRecords(records);
    }
  };

  return {
    checkIfRecordBeingBusy,
    ensureRecordsBusy,
  };
};
